import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import RouterPropsWrapper from "../../../../common/RouterPropsWrapper";
import validateAdvertiser from "../../../Validations";
import AdvertiserForm from "../../../advertiser/AdvertiserForm";
import { useChallengeInstance } from '../../../../hooks/useChallengeInstance';
import LoadingAnimation from "../../../../common/components/base/LoadingAnimation";
import SecondStepChallengeLayout from "../SecondStepChallengeLayout";
import {
  evaluateSecondStep,
  evaluateThirdStep
} from "../../../../settings/commonFunctions";

const AdvertisersAdServerStep2 = (props) => {
  const { match, history } = props;
  const challengeId = match.params.id;
  
  const [isClicked, setIsClicked] = useState(false);
  const [stepTime, setStepTime] = useState(0);
  
  // Fetch challenge instance data
  const { data: challengeInstanceData, isLoading, error } = useChallengeInstance(challengeId);

  // Start step timer
  useEffect(() => {
    const timer = setInterval(() => {
      setStepTime(prevTime => prevTime + 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const coreSubmit = async (values) => {
    const action = {
      actionNeeded: "complete",
      target: JSON.stringify({
        type: "advertiser",
        fields: {
          advertiserName: values.name.trim(),
          defaultLandingPage: values.defaultLandingUrl,
          category: values.category
        }
      }),
      stepTime: stepTime
    };
    let res = await evaluateSecondStep(action, challengeId);
    let value = res.data.challengeStepEvaluator;
    if (value) {
      let finalRes = await evaluateThirdStep(challengeId);
      if (finalRes?.challengeStepEvaluator) history.push(finalRes.challengeStepEvaluator.targetLocation + challengeId);
    }
  };

  const submit = (values) => {
    if (!isClicked) {
      setIsClicked(true);
      coreSubmit(values).then(() => {
        setTimeout(() => {
          setIsClicked(false);
        }, 800);
      });
    }
  };

  if (isLoading) return <LoadingAnimation />;
  if (error) return <div>Error loading challenge: {error.message}</div>;
  if (!challengeInstanceData?.challengeInstance?.challengeType) return <LoadingAnimation />;

  const challengeType = challengeInstanceData.challengeInstance.challengeType;

  return (
    <SecondStepChallengeLayout pageName={"Advertisers"} challengeType={challengeType}>
      <Formik
        initialValues={{ name: "", defaultLandingUrl: "", category: "" }}
        validate={validateAdvertiser}
        onSubmit={submit}
      >
        {({ isSubmitting, values, handleChange, setFieldValue, handleSubmit }) => (
          <AdvertiserForm
            values={values}
            caption="Category"
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            setFieldValue={setFieldValue}
            isSubmitting={isSubmitting}
          />
        )}
      </Formik>
    </SecondStepChallengeLayout>
  );
};

export default RouterPropsWrapper(AdvertisersAdServerStep2);
